
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';

import validateEmail from '../../common/validateEmail';
import DialogAlert from './DialogAlert';
import useAuth from '../hooks/useAuth';
import useAuthToken from '../hooks/mysliveckyportal/useAuthToken';
import useAuthUser from '../hooks/mysliveckyportal/useAuthUser';
import { getActions as authGetActions } from '../sagas/auth';

const classNames = mergeStyleSets({
    EditAccountForm: {
        backgroundColor: '#ffffff',
        width: '400px',
        padding: '16px'
    },
});

const EditAccountForm = ({styles, onCancelClick}) => {

    const dispatch = useDispatch();
    const authActions = authGetActions(dispatch);

    const auth = useAuth();
    const user = useAuthUser();
    const token = useAuthToken();

    const [email, setEmail] = useState(user.email);
    const [fullName, setFullName] = useState(user.fullName);

    const checkParams = () => {
        let errors = [];
        if (!fullName) {
            errors.push('Jméno a příjmení musí být zadané');
        }
        if (!email) {
            errors.push('E-mailová adresa musí být zadaný');
        }
        if (!validateEmail(email)) {
            errors.push('E-mailová adresa není platná');
        }

        return errors;
    }

    const handleCancelClick = () => {
        if (onCancelClick) {
            onCancelClick();
        }
    }

    const handleEditClick = async (event) => {
        let errors = checkParams();
        if (errors.length === 0) {
            authActions.editAccount(token, user.username, email, fullName);
        } else {
            await DialogAlert.show(errors.reduce(
                (previous, current) => {
                    return previous + `- ${current}<br/>`;
                }, 'Nejsou splněny následující podmínky a proto nelze v aktualizaci uživatelského účtu pokračovat:<br/></br/>'),
                {minWidth: 600});
        }
    }

    const handleChangeEmail = (event) => {
        setEmail(event.target.value);
    }

    const handleChangeFullName = (event) => {
        setFullName(event.target.value);
    }

    const getClassName = (name) => {
        return styles
            ? styles[name]
            : classNames[name];
    }

    return (
        <Stack className={getClassName('EditAccountForm')} tokens={{childrenGap: 16}}>
            <Stack.Item>
                <TextField
                    label="Uživatelské jméno"
                    disabled={true}
                    readOnly={true}
                    value={user.username}
                />
                <TextField
                    label="E-mailová adresa"
                    disabled={auth.loading}
                    value={email}
                    onChange={handleChangeEmail}
                />
                <TextField
                    label="Jméno a příjmení"
                    disabled={auth.loading}
                    value={fullName}
                    onChange={handleChangeFullName}
                />
            </Stack.Item>
            <Stack.Item>
                <Stack horizontal tokens={{childrenGap: 8}}>
                    <PrimaryButton
                        text="Aktualizovat účet"
                        disabled={auth.loading}
                        onClick={handleEditClick}
                    />
                    <DefaultButton
                        text="Zpět"
                        onClick={handleCancelClick}
                    />
                </Stack>
            </Stack.Item>
        </Stack>
    );
}

export default EditAccountForm;
